var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleGraphicFour1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 170,
    viewBox: "0 0 169 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M84.67 169.2C38.19 169.2 0.380005 131.39 0.380005 84.91C0.380005 38.43 38.19 0.619995 84.67 0.619995C131.15 0.619995 168.96 38.43 168.96 84.91C168.96 131.39 131.15 169.2 84.67 169.2ZM84.67 2.62999C39.3 2.62999 2.38 39.55 2.38 84.92C2.38 130.29 39.3 167.21 84.67 167.21C130.04 167.21 166.96 130.3 166.96 84.92C166.96 39.54 130.05 2.62999 84.67 2.62999Z",
    fill: "url(#paint0_linear_229_414)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_229_414",
    x1: 42.53,
    y1: 11.93,
    x2: 126.81,
    y2: 157.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D46D1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8D46D1",
    stopOpacity: 0.0144
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#8D46D1",
    stopOpacity: 0.1225
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#8D46D1",
    stopOpacity: 0.3025
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#8D46D1",
    stopOpacity: 0.5041
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#8D46D1",
    stopOpacity: 0.7056
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#8D46D1",
    stopOpacity: 0.8649
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8D46D1",
    stopOpacity: 0.9604
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D46D1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleGraphicFour1);
export default __webpack_public_path__ + "static/media/circle-graphic-four-1.bfa706bc2cecee763dcc51d96a62fbb9.svg";
export { ForwardRef as ReactComponent };